if (!customElements.get('eala-hero')) {
  customElements.define('eala-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.index = 0;
      const preloadPhotos = () => this.slides.slice(1).forEach(slide => slide.querySelector('img')?.setAttribute('loading', 'eager'));
      const firstPhoto = this.slides[0]?.querySelector('img');
      if (firstPhoto?.complete) preloadPhotos();
      else firstPhoto?.addEventListener('load', preloadPhotos, { signal, once: true });
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Number(this.dataset.interval) || 7000;
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));
      this.querySelector('[data-pause]')?.addEventListener('click', () => {
        this.paused = !this.paused;
        const button = this.querySelector('[data-pause]');
        button.setAttribute('aria-pressed', String(this.paused));
        button.setAttribute('aria-label', this.paused ? 'Play banner slideshow' : 'Pause banner slideshow');
        this.querySelector('[data-pause-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
        this.schedule();
      }, { signal });
      this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, { signal });
      this.addEventListener('pointerdown', (event) => { if (event.pointerType === 'touch') this.touchStart = { x: event.clientX, y: event.clientY }; }, { signal, passive: true });
      this.addEventListener('pointercancel', () => { this.touchStart = null; }, { signal });
      this.addEventListener('pointerup', (event) => {
        if (!this.touchStart) return;
        const dx = event.clientX - this.touchStart.x;
        const dy = event.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dy) < 50) { this.swiped = true; this.show(this.index + (dx < 0 ? 1 : -1)); }
      }, { signal });
      this.addEventListener('click', (event) => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, { signal, capture: true });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.reducedMotion.addEventListener('change', () => this.schedule(), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index); }
      }, { signal });
      this.schedule();
    }
    show(next, announce = true) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.hidden = !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.querySelector('img')?.setAttribute('loading', 'eager');
      });
      this.dots.forEach((dot, index) => { if (index === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      const counter = this.querySelector('[data-current-slide]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
      if (announce) this.querySelector('[data-slide-status]').textContent = `Banner ${this.index + 1} of ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.reducedMotion.matches || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1, false), this.interval);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
  });
}
